import React from 'react';
import Chart from 'components/pure/charts/custom/Chart';
import LineSeries from 'components/pure/charts/custom/LineSeries';
import AreaSeries from 'components/pure/charts/custom/AreaSeries';
import Guideline from 'components/pure/charts/custom/Guideline';
import range from 'lodash/range';
import Axis from 'components/pure/charts/custom/Axis';
import moment from 'moment';
import {scaleLinear, scaleTime} from 'd3-scale';
import {CalloutArrow} from 'charts';

const DEFAULT_VALUE = 24;

const CountChart = ({value, equality, period}) => {
  const yvalue = Number(value || DEFAULT_VALUE);
  const ymax = Math.ceil(yvalue * 1.15);
  const chartData = range(0, yvalue, yvalue / 20).map((value, i) => {
    return {date: moment().add(i, 'day'), value};
  });

  const margins = {left: 25, right: 0, top: 40, bottom: 5};
  const svgDimensions = {width: 275, height: 200};
  const xScale = scaleTime()
    .domain([chartData[0].date.toDate(), chartData[chartData.length - 1].date.toDate()])
    .range([margins.left, svgDimensions.width - margins.right]);

  const yScale = scaleLinear()
    .domain([0, ymax], [svgDimensions.height - margins.bottom, margins.top])
    .range([svgDimensions.height - margins.bottom, margins.top]);

  const scales = {xScale, yScale};
  const title = ` ${equality || 'More than'} ${yvalue}`;
  // attempt to adjust the callout arrow offset based on the number of
  // characters in the label (not a perfect solution since characters
  // are not monospaced)
  const calloutOffset = title.length * 6;
  return (
    <div className="chart-container count-chart">
      <div className="chart-title">
        <div>Count of times</div>
        <div>{title}</div>
      </div>
      <Chart
        svgDimensions={svgDimensions}
        defs={CalloutArrow.getDefinitions()}
        margins={margins}
        bordered={true}>
        <LineSeries className="line" data={chartData} scales={scales} />
        <AreaSeries className="area" data={chartData} scales={scales} fill={'#FFFFFF'} />
        <Guideline
          scales={scales}
          goal={yvalue}
          baseline={yvalue}
          xMin={chartData[0].date}
          xMax={chartData[chartData.length - 1].date}
        />
        <CalloutArrow
          from={{
            x: svgDimensions.width - 10,
            /* arrow overextends so just manually shorten it */
            y: yScale(yvalue) - 7,
          }}
          to={{x: margins.left + calloutOffset, y: 25}}
          delta={{x: 15, y: -20}}
        />
        <Axis
          orient="Bottom"
          scale={scales.xScale}
          translate={`translate(0, ${scales.yScale.range()[0]})`}
          tickSize={-5}
          ticks={9}
        />
        <Axis
          orient="Left"
          scale={scales.yScale}
          translate={`translate(${margins.left}, 0)`}
          tickSize={-5}
          ticks={2}
          tickFormat={s => s}
          tickValues={[0, yvalue]}
        />
      </Chart>
      <div className="chart-period">
        {period || '3 Months'}
        <div className="period-arrow-container">
          <div className="arrow-shaft" />
          <div className="arrow-head" />
        </div>
      </div>
    </div>
  );
};

export default CountChart;
